export class TrackerPair {
    public _id: string;
    public displayableId: string;
    public leftTracker: any;
    public rightTracker: any;
    public usedBy: any;
    public gym: any;

    constructor() { }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/trackerpair.ts